import { createContext } from 'react'

import type { State, Dispatch } from './reducer'

type SchedulingWizardContextType = [state: State, dispatch: Dispatch]

export const SchedulingWizardContext = createContext<
  SchedulingWizardContextType | undefined
>(undefined)
